import React from 'react';
import { useMode } from '../contexts/ModeContext';

const ModeToggle = () => {
  const { mode, toggleMode, config } = useMode();
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className="fixed top-20 right-4 z-40">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200">
        {/* Compact View */}
        <div className="flex items-center space-x-2 p-2">
          <span className="text-lg">{config.icon}</span>
          <button
            onClick={toggleMode}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              mode === 'AP' ? 'bg-blue-600' : 'bg-red-600'
            }`}
            title={`${mode} Mode`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                mode === 'AP' ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-gray-400 hover:text-gray-600 p-1"
          >
            <svg className={`w-4 h-4 transform transition-transform ${isExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        {/* Expanded View */}
        {isExpanded && (
          <div className="border-t border-gray-200 p-3 text-xs">
            <div className="font-semibold text-gray-800 mb-2">{config.name}</div>
            <div className="space-y-1 text-gray-600">
              {mode === 'AP' ? (
                <>
                  <div>• FRQ + CER</div>
                  <div>• Justification</div>
                  <div>• English</div>
                </>
              ) : (
                <>
                  <div>• Hızlı Çözüm</div>
                  <div>• Test Taktiği</div>
                  <div>• Türkçe</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModeToggle;
